import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import styles from "../../assets/styles/appointments.module.css"
import NoDataFound from '../common/NoDataFound';

interface PropsTypes {
    userDetails: UserDetailTypes[] | undefined;
}
export default function PreEmploymentTable({ userDetails }: PropsTypes) {

    return (
        <div>
            <TableContainer component={Paper} className='TableContainer'>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead className='custumTableHead'>
                        <TableRow className={styles.completeTableRow}>
                            <TableCell>Name</TableCell>
                            <TableCell align="right">Age</TableCell>
                            <TableCell align="right">Gender</TableCell>
                            <TableCell align="right">Phone</TableCell>
                            <TableCell align="right">Status</TableCell>
                            <TableCell align="right">Type</TableCell>
                        </TableRow>
                    </TableHead>
                    {
                        userDetails && userDetails?.length > 0 ?
                            <TableBody>
                                {
                                    userDetails?.map((item, index) => {
                                        const bgColor = item?.status ==="Scheduled" ? "#80B628" : item?.status ==="Completed" ? "#54a276": item?.status ==="Pending" ? "#ffcd29" : item?.status === "Cancelled" ? "#aa2626" : "#FF9800"
                                        const typeColor = item?.type ==="pre-enroll" ? "#0562cc" : "#6fc9c6"
                                        return (
                                            <TableRow
                                                key={index}
                                                className='custumTableRow'
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell component="th" scope="row">
                                                    <div className={styles.doctorSec}>
                                                        {item?.name}
                                                    </div>
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {item?.age}
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {item?.gender}
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {item?.phone}
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <div className='flex items-center justify-center'>
                                                        <button className={`outLineBtn ${styles.downloadPresBtn}`} style={{borderColor: bgColor, color: bgColor}} >{item?.status}</button>
                                                    </div>
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <div className='flex items-center justify-center'>
                                                        <button className={`outLineBtn ${styles.downloadPresBtn}`} style={{borderColor: typeColor, color: typeColor}} >{item?.type}</button>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })
                                }
                            </TableBody>
                            :
                            <TableBody>
                                <TableRow
                                    className='custumTableRow'
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row" colSpan={5}>
                                        <NoDataFound />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                    }
                </Table>
            </TableContainer>

        </div>
    );
}